export default __webpack_public_path__ + "static/media/map_your_custom_domain.afd7b95c.png";